module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBoldItalic-1ef67fc1b02cdea61d70041c5d980ad1.woff2";